import { render, staticRenderFns } from "./UpdateModifier.vue?vue&type=template&id=21a5bc96"
import script from "./UpdateModifier.vue?vue&type=script&lang=js"
export * from "./UpdateModifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports